// extracted by mini-css-extract-plugin
module.exports = {"answers":"style_answers__2Gi52","answer":"style_answer__2JzDQ","switch":"style_switch__25mGn"};